import { Icon } from '../components/Icon';
import { FINAL_CTA } from '../content/site';

export function FinalCta() {
  return (
    <section className="section bg-white">
      <div className="container-content">
        <div className="relative overflow-hidden rounded-3xl bg-aurora px-6 py-14 text-center sm:px-12">
          <div aria-hidden className="pointer-events-none absolute -right-10 -top-10 h-48 w-48 rounded-full bg-white/15 blur-2xl" />
          <div aria-hidden className="pointer-events-none absolute -bottom-12 -left-8 h-48 w-48 rounded-full bg-white/10 blur-2xl" />
          <h2 className="relative font-heading text-3xl font-bold text-white sm:text-4xl">
            {FINAL_CTA.headline}
          </h2>
          <p className="relative mx-auto mt-4 max-w-2xl text-lg text-white/90">{FINAL_CTA.subcopy}</p>
          <div className="relative mt-8 flex flex-col justify-center gap-3 sm:flex-row">
            <a href={FINAL_CTA.primaryCta.href} className="btn-warm">
              {FINAL_CTA.primaryCta.label}
              <Icon name="arrow-right" className="h-5 w-5" />
            </a>
            <a
              href={FINAL_CTA.secondaryCta.href}
              className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/40 bg-white/10 px-6 py-3 font-heading text-base font-semibold text-white transition-colors duration-200 hover:bg-white/20 cursor-pointer"
            >
              {FINAL_CTA.secondaryCta.label}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FinalCta;
